module.exports = __webpack_public_path__ + "img/image6@2x.0f29a6a0.png";